// extracted by mini-css-extract-plugin
export default {"tabLabelsList":"dcc_tabbox-tabLabelsList","tabLabelButton":"dcc_tabbox-tabLabelButton","tabLabelButtonActive":"dcc_tabbox-tabLabelButtonActive"};